import React, { useContext, useEffect } from 'react'

import {
    Container,
} from "reactstrap"

import { withRouter } from 'react-router-dom'
import CreateForm from './components/CreateForm'
import { GeneralContext } from '../../context/'

const Create = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setBreadcrumb } = generalContext

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: `Productos`,
            parentLink: '/products',
            item: `Crear Producto`
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <CreateForm />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Create)
